import ProductCombinations from './ProductCombinationsTable';

export default ProductCombinations;



// WEBPACK FOOTER //
// ./src/scenes/Products/ProductDetail/ProductVariantsTab/ProductCombinationsTable/index.ts